<template>
    <li class="context-menu__item">
        <button class="context-menu__button" :disabled="disabled" @click="onClick">
            <font-awesome-icon v-if="icon" class="context-menu__icon" :icon="[iconSet, icon]" />

            <span class="context-menu__text">
                {{ text }}
            </span>
        </button>
    </li>
</template>

<script>
export default {
    name: 'context-menu-item',

    props: {
        text: {
            type: String,
            required: true,
        },

        icon: {
            type: String,
            default: '',
        },

        iconSet: {
            type: String,
            default: 'fas',
        },

        disabled: {
            type: Boolean,
            default: false,
        },
    },

    methods: {
        onClick() {
            this.$emit('click');
        },
    },
};
</script>

<style lang="scss">
.context-menu__button:disabled {
    opacity: 0.5;
}
</style>
